// extracted by mini-css-extract-plugin
export default {"buttons":"e8LGx","button":"bbMDn","switcher":"GM_E6","switch":"ZqXpr","actived":"SLH0t","switchGroup":"PPx8_","allFiltersBtn":"WmTtI","stickyFilters":"ExIQy","secondary":"nLZda"};